import { render, staticRenderFns } from "./Bilhetagem.vue?vue&type=template&id=8d1ea8ae&scoped=true&"
import script from "./Bilhetagem.vue?vue&type=script&lang=js&"
export * from "./Bilhetagem.vue?vue&type=script&lang=js&"
import style0 from "./Bilhetagem.vue?vue&type=style&index=0&id=8d1ea8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1ea8ae",
  null
  
)

export default component.exports